interface InsideIconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
}

const MonitoringIcon: React.FC<InsideIconProps> = ({ width = 35, height = 24, color = '#91B1BE', className = '' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    className={className}
    viewBox='0 0 36 35'
    fill='none'
  >
    <g className='dark:child:stroke-primary-500' clipPath='url(#clip0_4_399)'>
      <path
        d='M22.116 33.687H13.4L14.49 27.15H21.027L22.116 33.687Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M10.131 33.684H25.385' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M5.772 1.003H29.742C29.742 1.003 34.1 1.003 34.1 5.361V22.791C34.1 22.791 34.1 27.149 29.742 27.149H5.772C5.772 27.149 1.414 27.149 1.414 22.791V5.358C1.414 5.358 1.417 1.003 5.772 1.003Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.41699 15.528L7.22799 9.717C7.43235 9.51304 7.70927 9.39849 7.99799 9.39849C8.28671 9.39849 8.56364 9.51304 8.76799 9.717L11.543 12.579C11.7473 12.783 12.0243 12.8975 12.313 12.8975C12.6017 12.8975 12.8786 12.783 13.083 12.579L18.894 6.768'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M1.41699 21.338H34.101' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M21.026 12.622V16.622' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M29.743 12.622V16.622' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M25.384 9.354V16.614' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </g>
    <defs>
      <clipPath id='clip0_4_399'>
        <rect width='35.101' height='34.687' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default MonitoringIcon;
